// extracted by css-extract-rspack-plugin
export default {"card":"qeb8GKUg6NC_WiS4","directionIcon":"_Od_wGww0gQVLgEI"};